import { ApiEnvironment } from '../../models/api-environment';

export class AccountsEnvironment extends ApiEnvironment {
  get copilotActionsUrl() {
    return `${this.baseUrl}/support/copilot-actions`;
  }

  get summaryUrl() {
    return `${this.baseUrl}/summary`;
  }

  get assetsUrl() {
    return `${this.baseUrl}/users`;
  }

  get usersLogsUrl() {
    return `${this.baseUrl}/users/logs`;
  }

  get deviceLogsUrl() {
    return `${this.baseUrl}/device/logs`;
  }

  get companyUrl() {
    return `${this.baseUrl}/company`;
  }

  get companySettingsUrl() {
    return `${this.baseUrl}/company/settings`;
  }

  get usersBulkUrl() {
    return `${this.baseUrl}/users/bulk`;
  }

  get licenseUrl() {
    return `${this.baseUrl}/license`;
  }

  get licenseBulkUrl() {
    return `${this.baseUrl}/license/bulk`;
  }

  licenseProductIdBulkUrl(productId: number) {
    return `${this.baseUrl}/license/${productId}/bulk`;
  }

  get companyOrdersUrl() {
    return `${this.baseUrl}/company/orders?status=Pending`;
  }

  configSettingsAccountUrl(accountAlias: string) {
    return `${this.baseUrl}/configuration/settings/account/${accountAlias}`;
  }

  get configSettingsAppUrl() {
    return `${this.baseUrl}/configuration/settings/application/21`;
  }

  configSettingsIdUrl(configSettingsId: string) {
    return `${this.baseUrl}/configuration/settings/${configSettingsId}`;
  }
}

export const accountsEnvironment = new AccountsEnvironment();
